var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidEmail } from '../../../../utils/validation';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import Message from '../../../../components/Message';
import { SubmitActions, ModalSteps } from '../../constants';
import styles from '../../styles.module.scss';
const Login = ({ onSwitchStep = null, onSetLoading = null, onSubmitCallback, apiUrl = '' }) => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState([]);
    const [isSubmitErrorVisible, setSubmitErrorVisible] = useState(false);
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (isLoading)
            return;
        const formErrors = validateFormPayload(formData);
        if (formErrors.length > 0) {
            setErrors(formErrors);
            return;
        }
        setErrors([]);
        setLoading(true);
        setSubmitErrorVisible(false);
        if (onSetLoading != null)
            onSetLoading(true);
        try {
            const response = yield fetch(`${apiUrl}/api/user/authenticate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
            if (response.ok) {
                if (onSubmitCallback != null) {
                    onSubmitCallback(response, SubmitActions.LOGIN);
                    return;
                }
                const redirectUrl = yield response.json();
                window.location.href = redirectUrl;
            }
            else {
                setSubmitErrorVisible(true);
                setLoading(false);
            }
            if (onSetLoading != null)
                onSetLoading(false);
        }
        catch (_a) {
            setSubmitErrorVisible(true);
            setLoading(false);
        }
        if (onSetLoading != null)
            onSetLoading(false);
    });
    const submitErrorElement = isSubmitErrorVisible ? (_jsx("div", Object.assign({ className: styles.formItem }, { children: _jsx(Message, Object.assign({ "data-cy": "login-step-generic-error", type: "error" }, { children: t('global.errors.login') })) }))) : null;
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmit, className: styles.form, "data-cy": "login-step" }, { children: [_jsx("h4", Object.assign({ className: styles.title }, { children: t('authentication.login.title') })), _jsx("div", Object.assign({ className: styles.formItem }, { children: _jsx(Input, { type: "email", name: "email", autoComplete: "username", label: t('authentication.login.emailLabel'), value: formData.email, onChange: (event) => setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { email: event.target.value }))), isError: errors.includes('email'), errorMessage: errors.includes('email') ? t('global.errors.email.invalid') : null, "data-cy": "login-step-email", disabled: isLoading }) })), _jsx("div", Object.assign({ className: styles.formItem }, { children: _jsx(Input, { type: "password", name: "password", autoComplete: "current-password", label: t('authentication.login.passwordLabel'), value: formData.password, onChange: (event) => setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { password: event.target.value }))), isError: errors.includes('password'), errorMessage: errors.includes('password') ? t('global.errors.password.empty') : null, "data-cy": "login-step-password", disabled: isLoading }) })), submitErrorElement, _jsx(Button, Object.assign({ type: "submit", color: "pink", isLoading: isLoading, "data-cy": "login-step-submit-button", size: "fluid" }, { children: t('authentication.login.submit') })), onSwitchStep != null ? (_jsxs("div", Object.assign({ className: styles.formOtherActions }, { children: [_jsx("a", Object.assign({ href: "", onClick: (event) => {
                            event.preventDefault();
                            onSwitchStep(ModalSteps.RESET_PASSWORD);
                        }, "data-cy": "login-step-reset-password-button" }, { children: t('authentication.login.forgotPassword') })), _jsxs("p", { children: [t('authentication.signupText'), ' ', _jsx("a", Object.assign({ href: "", onClick: (event) => {
                                    event.preventDefault();
                                    onSwitchStep(ModalSteps.USER_INFO);
                                }, "data-cy": "login-step-signup-button" }, { children: t('authentication.signupLink') }))] })] }))) : null] })));
    function validateFormPayload(data) {
        const formErrors = [];
        if (!isValidEmail(data.email)) {
            formErrors.push('email');
        }
        if (data.password.length === 0) {
            formErrors.push('password');
        }
        return formErrors;
    }
};
export default Login;
